(function () {
  'use strict';

  if (window.__evCollectionFiltersReady) return;
  window.__evCollectionFiltersReady = true;

  var activeDrawer = null;
  var activeOpener = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function overlayFor(drawer) {
    return drawer.parentElement.querySelector('.plp__drawer-overlay');
  }

  function openerFor(drawer) {
    return document.querySelector('[aria-controls="' + drawer.id + '"]');
  }

  function initializeDrawer(drawer) {
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
  }

  function initializeSort(select) {
    select.addEventListener('change', function () {
      var form = select.form;
      if (!form) return;
      if (select.closest('[data-plp-filter-drawer]')) return;

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  function setOpen(drawer, open, opener) {
    if (!drawer) return;

    var overlay = overlayFor(drawer);
    var trigger = opener || openerFor(drawer);
    var scrollKey = 'collection-filters-' + drawer.id;

    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    drawer.inert = !open;
    if (open) drawer.setAttribute('data-open', 'true');
    else drawer.removeAttribute('data-open');

    if (overlay) {
      if (open) overlay.setAttribute('data-open', 'true');
      else overlay.removeAttribute('data-open');
    }
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      activeDrawer = drawer;
      activeOpener = trigger;
      if (window.theme && window.theme.lockScroll) window.theme.lockScroll(scrollKey);
      var closeButton = drawer.querySelector('[data-plp-filter-close]');
      if (closeButton) closeButton.focus();
    } else {
      var form = drawer.querySelector('form');
      if (form) form.reset();
      if (window.theme && window.theme.unlockScroll) window.theme.unlockScroll(scrollKey);
      if (activeDrawer === drawer) activeDrawer = null;
      if (activeOpener && document.contains(activeOpener)) activeOpener.focus();
      activeOpener = null;
    }
  }

  function trapFocus(event) {
    var focusable = Array.from(activeDrawer.querySelectorAll(FOCUSABLE)).filter(function (element) {
      return element.getClientRects().length > 0;
    });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var focusIsOutside = !activeDrawer.contains(document.activeElement);

    if (event.shiftKey && (document.activeElement === first || focusIsOutside)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || focusIsOutside)) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-plp-size-picker][open]').forEach(function (picker) {
      if (!picker.contains(event.target)) picker.open = false;
    });
    var opener = event.target.closest('[data-plp-filter-open]');
    if (opener) {
      setOpen(document.getElementById(opener.getAttribute('aria-controls')), true, opener);
      return;
    }

    if (event.target.closest('[data-plp-filter-close]')) {
      setOpen(activeDrawer, false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !activeDrawer) {
      var picker = document.querySelector('[data-plp-size-picker][open]');
      if (picker) { picker.open = false; picker.querySelector('summary').focus(); }
    }
    if (event.key === 'Tab' && activeDrawer) trapFocus(event);
    if (event.key === 'Escape' && activeDrawer) setOpen(activeDrawer, false);
  });

  document.querySelectorAll('[data-plp-filter-drawer]').forEach(initializeDrawer);
  document.querySelectorAll('[data-plp-sort]').forEach(initializeSort);

  // One native sort field: mobile stages it with the other drawer choices;
  // desktop keeps it in the toolbar. Resizing never copies or loses its value.
  document.querySelectorAll('.plp').forEach(function (collection) {
    var toolbar = collection.querySelector('.plp__toolbar');
    var sort = collection.querySelector('.plp__sort');
    var slot = collection.querySelector('[data-plp-sort-slot]');
    var density = collection.querySelector('.plp__density');
    if (slot && sort && toolbar) {
      var mobile = window.matchMedia('(max-width: 749px)');
      function placeSort() {
        if (mobile.matches) slot.appendChild(sort);
        else toolbar.insertBefore(sort, density);
      }
      placeSort();
      mobile.addEventListener('change', placeSort);
    }
    function setDensity(value) {
      value = value === 'large' ? 'large' : 'compact';
      collection.dataset.gridDensity = value;
      collection.querySelectorAll('[data-plp-density]').forEach(function (choice) {
        choice.setAttribute('aria-pressed', String(choice.dataset.plpDensity === value));
      });
      const columns = Number(collection.querySelector('.plp__grid')?.style.getPropertyValue('--cols-desktop')) || 4;
      const sizes = value === 'large' ? '(min-width: 990px) 50vw, 100vw' : '(min-width: 990px) ' + (100 / columns) + 'vw, 50vw';
      collection.querySelectorAll('.plp__grid img').forEach(function (image) { image.sizes = sizes; });
      try { window.sessionStorage.setItem('ev:collection-density', value); } catch (_) { /* Layout still works when storage is unavailable. */ }
    }
    let savedDensity;
    try { savedDensity = window.sessionStorage.getItem('ev:collection-density'); } catch (_) { /* Use the default layout. */ }
    setDensity(savedDensity);
    collection.querySelectorAll('[data-plp-density]').forEach(function (button) {
      button.addEventListener('click', function () {
        setDensity(button.dataset.plpDensity);
      });
    });
  });
})();
